/** Codes the platform looks surveys up by; changing one breaks that feature. */
export const HARDCODED_SURVEY_CODES = [
  "pesam",
  "k_bild",
  "lpf_impacts",
  "lpf_symptoms",
  "vas_cough",
  "vas_fatigue_survey",
  "vas_shortness_of_breath",
  "vas_general_well_being",
  "vas_ankle_swelling",
  "vas_fluid_related_symptoms",
  "borg_scale_perceived_exertion",
];

export const generateCodeFromName = (name: string): string =>
  name.trim().toLowerCase().split(" ").join("_");

export const isValidSurveyCode = (code: string) =>
  code === "" || /^[a-z0-9_]+$/.test(code);
